var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7061 18.2931C19.799 18.386 19.8727 18.4963 19.923 18.6177C19.9733 18.7391 19.9992 18.8692 19.9992 19.0006C19.9992 19.132 19.9733 19.2621 19.923 19.3835C19.8727 19.5048 19.799 19.6151 19.7061 19.7081C19.6132 19.801 19.5029 19.8747 19.3815 19.9249C19.2601 19.9752 19.13 20.0011 18.9986 20.0011C18.8672 20.0011 18.7371 19.9752 18.6157 19.9249C18.4943 19.8747 18.384 19.801 18.2911 19.7081L9.9986 11.4143L1.7061 19.7081C1.51846 19.8957 1.26397 20.0011 0.998603 20.0011C0.733239 20.0011 0.478744 19.8957 0.291103 19.7081C0.103462 19.5204 -0.00195312 19.2659 -0.00195312 19.0006C-0.00195313 18.7352 0.103462 18.4807 0.291103 18.2931L8.58485 10.0006L0.291103 1.70806C0.103462 1.52042 -0.00195312 1.26592 -0.00195312 1.00056C-0.00195312 0.735192 0.103462 0.480697 0.291103 0.293056C0.478744 0.105415 0.733239 0 0.998603 0C1.26397 0 1.51846 0.105415 1.7061 0.293056L9.9986 8.58681L18.2911 0.293056C18.4787 0.105415 18.7332 -5.23096e-09 18.9986 0C19.264 5.23096e-09 19.5185 0.105415 19.7061 0.293056C19.8937 0.480697 19.9992 0.735192 19.9992 1.00056C19.9992 1.26592 19.8937 1.52042 19.7061 1.70806L11.4124 10.0006L19.7061 18.2931Z",
    fill: "#343330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.4cf1f3ba47c86f34e92df3a9b7c468d5.svg";
export { ForwardRef as ReactComponent };